module.exports = {"name":"Nadpis (text)","icon":"<i class='material-icons'>font_download</i>","widget":{"type":"pure-html","initData":{"html":"<h1>Nadpis</h1>"}}}


//////////////////
// WEBPACK FOOTER
// ./src/blocks/title/title.json
// module id = 400
// module chunks = 0